import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getSelectRolePath = () => {
  return urlHelper('/auth/select-role');
};
